import React from "react";
import { X, Sparkles, Tag } from "lucide-react";

export default function ChangelogModal({
  open,
  onClose,
  current,
  items = [],
  isWhatsNew = false,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm"
      data-testid="changelog-modal"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start justify-between gap-3 p-5 border-b border-slate-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-indigo-600 text-white flex items-center justify-center shrink-0">
              <Sparkles className="w-5 h-5" />
            </div>
            <div>
              <h2 className="font-heading font-bold text-lg text-slate-900">
                {isWhatsNew ? "Apa yang baru" : "Catatan Versi"}
              </h2>
              <p className="text-sm text-slate-500">
                {isWhatsNew
                  ? `Aplikasi diperbarui ke versi v${current}`
                  : `Versi saat ini v${current}`}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-700 p-1"
            data-testid="changelog-close"
            aria-label="Tutup"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="p-5 overflow-y-auto space-y-5">
          {items.map((item, idx) => {
            const isLatest = item.version === current;
            return (
              <div key={item.version} className="relative pl-4">
                <span
                  className={`absolute left-0 top-1.5 w-2 h-2 rounded-full ${
                    isLatest ? "bg-indigo-600" : "bg-slate-300"
                  }`}
                />
                <div className="flex items-center gap-2 flex-wrap">
                  <span
                    className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full ${
                      isLatest
                        ? "bg-indigo-100 text-indigo-700"
                        : "bg-slate-100 text-slate-600"
                    }`}
                  >
                    <Tag className="w-3 h-3" />v{item.version}
                  </span>
                  {isLatest && (
                    <span className="text-[10px] uppercase tracking-wide font-bold text-indigo-600">
                      Terbaru
                    </span>
                  )}
                  {item.date && (
                    <span className="text-xs text-slate-400">{item.date}</span>
                  )}
                </div>
                {item.title && (
                  <p className="text-sm font-medium text-slate-800 mt-1">
                    {item.title}
                  </p>
                )}
                <ul className="mt-1 space-y-1">
                  {(item.changes || []).map((c, i) => (
                    <li
                      key={i}
                      className="text-sm text-slate-600 flex gap-2 leading-snug"
                    >
                      <span className="text-indigo-400 mt-1">&bull;</span>
                      <span>{c}</span>
                    </li>
                  ))}
                </ul>
                {idx < items.length - 1 && (
                  <div className="border-b border-slate-100 mt-4" />
                )}
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-slate-100 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium"
            data-testid="changelog-ack"
          >
            {isWhatsNew ? "Mengerti" : "Tutup"}
          </button>
        </div>
      </div>
    </div>
  );
}
